import { v4 as uuidV4 } from 'uuid';

const SAS_USER_SESSION_ID_STORAGE_KEY = 'sas-user-session-id';

export const getSasUserSessionId = (): string => {
  const userSessionId = window?.sessionStorage?.getItem(SAS_USER_SESSION_ID_STORAGE_KEY);

  if (userSessionId) {
    return userSessionId;
  }

  const value = uuidV4();
  window?.sessionStorage?.setItem(SAS_USER_SESSION_ID_STORAGE_KEY, value);

  return value;
};

export const getSasCorrelationId = (): string => uuidV4();
